import { render, staticRenderFns } from "./trackedItemCardInsights.vue?vue&type=template&id=46c1637a&scoped=true"
import script from "./trackedItemCardInsights.js?vue&type=script&lang=js&external"
export * from "./trackedItemCardInsights.js?vue&type=script&lang=js&external"
import style0 from "./trackedItemCardInsights.vue?vue&type=style&index=0&id=46c1637a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1637a",
  null
  
)

export default component.exports